import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _Symbol$iterator from 'babel-runtime/core-js/symbol/iterator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import { isArray, isString, isObject, hasValue } from './typeChecks';

var ErrorIterator = function ErrorIterator(instance) {
    var curKey = 0;

    return {
        next: function next() {
            var nextVal = instance.errorByIndex(curKey);

            // Note: If a custom error handler does not coerce undefined to null,
            //  the iterator will stop too early
            //
            // Feel free to submit a PR if this annoys you!
            if (nextVal === undefined) {
                return { done: true };
            } else {
                curKey += 1;

                return {
                    value: nextVal
                };
            }
        }
    };
};

var bindAndCoerce = function bindAndCoerce(error, fieldName) {
    var res = error || null;

    if (res !== null) {
        res.bindToField(fieldName);
    }

    return res;
};

export var ValidationErrorInterface = function () {
    function ValidationErrorInterface(errors) {
        _classCallCheck(this, ValidationErrorInterface);

        // Store errors
        this._errors = errors;
    }

    _createClass(ValidationErrorInterface, [{
        key: _Symbol$iterator,


        // Support for .. of loops
        value: function value() {
            return ErrorIterator(this);
        }

        /**
         * Iterator used for .forEach/.filter/.map
         */

    }, {
        key: '_iter',
        value: function _iter() {
            // eslint-disable-line class-methods-use-this
            return this._errors;
        }

        /**
         * Used by firstError and iteration protocol
         */

    }, {
        key: 'errorByIndex',
        value: function errorByIndex(index) {
            // eslint-disable-line class-methods-use-this
            return this._errors[index];
        }

        /* istanbul ignore next: just an interface */

    }, {
        key: 'hasError',
        value: function hasError() {
            // eslint-disable-line class-methods-use-this
            return 'ValidationErrorInterface::asString is not implemented';
        }
    }, {
        key: 'bindToField',
        value: function bindToField(fieldName) {
            // istanbul ignore else: never false in tests
            if (process.env.NODE_ENV !== 'production') {
                if (this.fieldName && this.fieldName !== fieldName) {
                    // eslint-disable-next-line no-console
                    console.error('ValidationErrorInterface: Unexpected rebind of ' + this + ' as ' + fieldName + ' (was ' + this.fieldName + ')');
                }
            }

            this.fieldName = fieldName;
        }

        /* istanbul ignore next: just an interface */

    }, {
        key: 'asString',
        value: function asString() {
            // eslint-disable-line class-methods-use-this
            return 'ValidationErrorInterface::asString is not implemented';
        }
    }, {
        key: 'toString',
        value: function toString() {
            return this.asString();
        }
    }, {
        key: 'map',
        value: function map() {
            var _iter2;

            return (_iter2 = this._iter()).map.apply(_iter2, arguments);
        }
    }, {
        key: 'forEach',
        value: function forEach() {
            var _iter3;

            return (_iter3 = this._iter()).forEach.apply(_iter3, arguments);
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _iter4;

            return (_iter4 = this._iter()).filter.apply(_iter4, arguments);
        }
    }, {
        key: 'errors',
        get: function get() {
            return this._errors;
        }
    }]);

    return ValidationErrorInterface;
}();

export var SingleValidationError = function (_ValidationErrorInter) {
    _inherits(SingleValidationError, _ValidationErrorInter);

    function SingleValidationError(errors) {
        _classCallCheck(this, SingleValidationError);

        // istanbul ignore else: never false in tests
        if (process.env.NODE_ENV !== 'production') {
            if (!isArray(errors) || errors.filter(function (x) {
                return !isString(x);
            }).length > 0) {
                // eslint-disable-next-line no-console
                console.error('SingleValidationError: `errors` argument must be an array of strings');
            }
        }

        return _possibleConstructorReturn(this, (SingleValidationError.__proto__ || _Object$getPrototypeOf(SingleValidationError)).call(this, errors));
    }

    _createClass(SingleValidationError, [{
        key: 'hasError',
        value: function hasError() {
            return this._errors.length > 0;
        }
    }, {
        key: 'asString',
        value: function asString() {
            var glue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';

            return this._errors.join(glue || '');
        }
    }]);

    return SingleValidationError;
}(ValidationErrorInterface);

export var ParentValidationErrorInterface = function (_ValidationErrorInter2) {
    _inherits(ParentValidationErrorInterface, _ValidationErrorInter2);

    function ParentValidationErrorInterface() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, ParentValidationErrorInterface);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = ParentValidationErrorInterface.__proto__ || _Object$getPrototypeOf(ParentValidationErrorInterface)).call.apply(_ref, [this].concat(args))), _this2), _this2.nonFieldErrors = null, _temp), _possibleConstructorReturn(_this2, _ret);
    }
    // If null, there are no nonFieldErrors
    //
    // Some parent validation errors cannot have nonFieldErrors (e.g. ListValidationError,
    //  since a list cannot have attributes in JSON). Helps keep things DRY, since the result
    //  of getError & firstError won't change if nonFieldErrors is always null.


    _createClass(ParentValidationErrorInterface, [{
        key: 'getError',
        value: function getError(fieldName, allowNonFields) {
            if (this.errors[fieldName] || allowNonFields && this.nonFieldErrors) {
                return this.errors[fieldName] || this.nonFieldErrors || null;
            }

            return null;
        }
    }, {
        key: 'firstError',
        value: function firstError(allowNonField) {
            if (allowNonField && this.nonFieldErrors) {
                return this.nonFieldErrors;
            }

            return this.errorByIndex(0) || null;
        }
    }]);

    return ParentValidationErrorInterface;
}(ValidationErrorInterface);

export var ListValidationError = function (_ParentValidationErro) {
    _inherits(ListValidationError, _ParentValidationErro);

    function ListValidationError(errors) {
        _classCallCheck(this, ListValidationError);

        // istanbul ignore else: never false in tests
        if (process.env.NODE_ENV !== 'production') {
            // Takes: anything thats not a ValidationError (besides null)
            var filterFn = function filterFn(x) {
                if (x === null) {
                    return false;
                }

                return !x || !(x instanceof ValidationErrorInterface);
            };

            if (errors) {
                if (!isArray(errors) || errors.filter(filterFn).length > 0) {
                    /* eslint-disable no-console */
                    console.error('ListValidationError: `errors argument` must be an array of ValidationErrorInterface? instances');
                    console.error('    Supported Builtins: null/SingleValidationError/ListValidationError/ValidationError');
                    /* eslint-enable no-console */
                }
            }
        }

        // MAP: falsy to null, bind all errors w/ their fieldName
        return _possibleConstructorReturn(this, (ListValidationError.__proto__ || _Object$getPrototypeOf(ListValidationError)).call(this, (errors || []).map(bindAndCoerce)));
    }

    _createClass(ListValidationError, [{
        key: 'hasError',
        value: function hasError() {
            return this._errors.filter(function (x) {
                return x && x.hasError && x.hasError();
            }).length > 0;
        }
    }, {
        key: 'asString',
        value: function asString() {
            var glue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '; ';

            return this._errors.map(function (value, key) {
                return key + ': ' + value.asString();
            }).join(glue);
        }
    }]);

    return ListValidationError;
}(ParentValidationErrorInterface);

export var ValidationError = function (_ParentValidationErro2) {
    _inherits(ValidationError, _ParentValidationErro2);

    function ValidationError(errors, nonFieldErrors) {
        _classCallCheck(this, ValidationError);

        // istanbul ignore else: never false in tests
        if (process.env.NODE_ENV !== 'production') {
            // Takes: anything thats not a ValidationError (besides null)
            var filterFn = function filterFn(key) {
                if (errors[key] === null) {
                    return false;
                }

                return !errors[key] || !(errors[key] instanceof ValidationErrorInterface);
            };

            if (errors) {
                if (!isObject(errors) || _Object$keys(errors).filter(filterFn).length > 0) {
                    /* eslint-disable no-console */
                    console.error('ListValidationError: `errors argument` must be an object of ValidationErrorInterface? instances');
                    console.error('    Supported Builtins: null/SingleValidationError/ListValidationError/ValidationError');
                    /* eslint-enable no-console */
                }
            }
        }

        // MAP: falsy to null, bind all errors w/ their fieldName
        var mutErrors = {};
        _Object$keys(errors || {}).forEach(function (fieldName) {
            mutErrors[fieldName] = bindAndCoerce(errors[fieldName], fieldName);
        });

        // Bind nonFieldErrors
        var _this4 = _possibleConstructorReturn(this, (ValidationError.__proto__ || _Object$getPrototypeOf(ValidationError)).call(this, mutErrors));

        _this4.nonFieldErrors = nonFieldErrors || null;
        if (_this4.nonFieldErrors) {
            _this4.nonFieldErrors.bindToField('nonFieldErrors');
        }

        // store a list of keys (for iteration)
        _this4._errKeys = _Object$keys(_this4._errors);
        return _this4;
    }

    _createClass(ValidationError, [{
        key: 'hasError',
        value: function hasError() {
            return this.nonFieldErrors !== null || this._errKeys.length > 0;
        }
    }, {
        key: 'asString',
        value: function asString() {
            var _this5 = this;

            var glue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '; ';

            var prefix = '';

            if (this.nonFieldErrors) {
                prefix = '' + this.nonFieldErrors + (this._errKeys.length ? glue : '');
            }

            return prefix + this._errKeys.map(function (k) {
                return k + ': ' + _this5._errors[k].asString();
            }).join(glue);
        }
    }, {
        key: '_iter',
        value: function _iter() {
            var _this6 = this;

            return _Object$keys(this._errors).map(function (x) {
                return _this6.errors[x];
            });
        }
    }, {
        key: 'errorByIndex',
        value: function errorByIndex(index) {
            return this.errors[this._errKeys[index]];
        }
    }]);

    return ValidationError;
}(ParentValidationErrorInterface);

/**
 * Convert errorText (json or normal text) to a ValidationError
 *
 * @param {*} errorText
 * @param {Object} parentConfig
 */
export function parseErrors(errorText, parentConfig) {
    var error = null;

    if (isString(errorText)) {
        if (errorText) {
            try {
                error = JSON.parse(errorText);
            } catch (e) {
                // if json parsing fails, handle as text
                error = errorText;
            }
        } else {
            error = '';
        }
    } else {
        error = errorText;
    }

    // force undefined to be a string
    if (error === undefined) {
        error = '' + undefined;
    }

    var result = parentConfig.prepareError(error, parentConfig);

    if (!result) {
        return result;
    }

    // istanbul ignore else: can only happen w/ custom prepareError
    if (result instanceof ValidationErrorInterface) {
        return result.hasError() ? result : null;
    }

    // For anything else, just return the result (why would anyone do this though?)
    // istanbul ignore next: can only happen w/ custom prepareError
    return result;
}

/**
 * Convert an error into a subclass of ValidationErrorInterface
 *
 * @param {*} err
 * @param {Object} parentConfig
 */
export function prepareError(err, parentConfig) {
    if (isString(err)) {
        // Note: SingleValidationError contains a list of errors per field
        return new SingleValidationError([err || '#$empty-message$#']);
    } else if (isArray(err)) {
        // If the array contains only strings, turn it into a SingleValidationError
        if (err.length > 0 && err.filter(function (x) {
            return isString(x);
        }).length === err.length) {
            return new SingleValidationError(err);
        }

        // Parse children of the error and continue
        var errors = err.map(function (x) {
            return parentConfig.prepareError(x, parentConfig);
        });

        // Should be a nested error, turn it into ListValidationError
        return new ListValidationError(errors);
    } else if (isObject(err)) {
        var _errors = typeof err.errors === 'undefined' ? err : err.errors;

        var resNonField = null;
        var resErrors = {};

        _Object$keys(_errors).forEach(function (key) {
            var error = parentConfig.prepareError(_errors[key], parentConfig);

            if (key === 'non_field_errors') {
                resNonField = error;
            }

            // note: we only add errors as fields if we can parse the field error (or need to)
            else if (error !== null) {
                    resErrors[key] = error;
                }
        });

        // if no errors ensure atleast a default message is set
        if (_Object$keys(resErrors).length === 0 && !resNonField) {
            resNonField = new SingleValidationError([err || '#$empty-message$#']);
        }

        return new ValidationError(resErrors, resNonField);
    }

    // If undefined/null, lets turn it into a null
    else if (!hasValue(err)) {
            return null;
        }

        // Everything else gets turned into a string (bools, numbers, binary)
        else {
                // Note: Empty string means there is no error
                err = '' + err;

                // istanbul ignore else: only custom classes w/ custom toString
                if (err) {
                    return new SingleValidationError([err]);
                }

                // istanbul ignore next: only custom classes w/ custom toString
                return null;
            }
}


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/validationError.js
// module id = 267
// module chunks = 0